import { Component, effect, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { ReportsTransactionHistoryComponent } from './components/reports-transaction-history/reports-transaction-history.component';
import { ReportsWalletsComponent } from './components/reports-wallets/reports-wallets.component';
import { ReportsUtilizationComponent } from './components/reports-utilization/reports-utilization.component';
import { ReportsUserActivityComponent } from './components/reports-user-activity/reports-user-activity.component';
import { HasPermissionDirective } from '@olv/ui-shared/directives/has-permission.directive';
import { Resources, Scopes } from '@olv/ui-shared/models/settlement-permissions.model';
import { MerchantService } from '@olv/ui-shared/services/merchant.service';
import { ReportsLedgerComponent } from './components/reports-ledger/reports-ledger.component';
import { MatIconModule } from '@angular/material/icon';
import { AppContextService } from '@olv/ui-shared/services/app-context.service';
import { ReportsAssetsComponent } from "./components/reports-assets/reports-assets.component";
import { TabStripDirective } from '@olv/ui-shared/directives/tab-strip.directive';
import { ActivatedRoute, Router } from '@angular/router';
import { stripQueryParam } from '../../utils/navigation.utils';

@Component({
  selector: 'app-reports',
  standalone: true,
  imports: [
    TabStripDirective,
    CommonModule,
    MatCardModule,
    ReportsTransactionHistoryComponent,
    ReportsWalletsComponent,
    ReportsUtilizationComponent,
    ReportsUserActivityComponent,
    ReportsLedgerComponent,
    HasPermissionDirective,
    MatIconModule,
    ReportsAssetsComponent
],
  templateUrl: './reports.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit {
  private merchantService = inject(MerchantService);

  protected readonly Resources = Resources;
  protected readonly Scopes = Scopes;
  private readonly appCtx = inject(AppContextService);
  private readonly appName = this.appCtx.getAppName();
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  sideComponentOpen = false; // Flag to control the sidebar component
  activeTab = 'Transaction History';
  isSettlementApp = this.appName === 'settlement';
  transactionSearch = '';

  constructor() {
    effect(() => {
      const sidebarOpen = this.merchantService.sidebarOpenSignal();
      if (sidebarOpen) {
        this.sideComponentOpen = true;
      } else {
        this.sideComponentOpen = false;
      }
    });
  }

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    const transactionId = params.get('transactionId');

    if (!transactionId) {
      return;
    }

    this.transactionSearch = transactionId;

    stripQueryParam(params, 'transactionId', this.router, this.location);
  }

  selectTab(tabName: string): void {
    this.transactionSearch = '';
    this.activeTab = tabName;
    this.sideComponentOpen = false;
    this.merchantService.closeSidebar();
  }
}
